import React from 'react';
import './Style.css';

import { useUser } from '../../Context/User';

const Index = ({ ...props }) => {
    const { address } = useUser();
    return (
        <div className="shipping_details">
            <div style={{ marginBottom: '1.4rem' }} className="home_head">
                <h2 className="home_heading">Shipping Details</h2>
            </div>
            <div className="shipping_details_content">
                <div className="shipping_details_content_partition">
                    <h4>{address.name}</h4>
                    <p>{`${address.add1},${address.add2}`}</p>
                    <p>{address.add3}</p>
                    <p>{`${address.city} ${address.state} - ${address.pin}`}</p>
                    <p>{address.country}</p>
                    <p>{address.phone}</p>
                    <p>{address.email}</p>
                </div>
                <div className="shipping_details_content_partition">
                    <h4>Shipped By {address.shipper}</h4>
                    <p>Rs. {address.charges}</p>
                </div>
            </div>
        </div>
    );
};

export default Index;
